module.exports = __webpack_public_path__ + "static/projekt-opakowania-napoju-lewandowski-d0c26de4fcdda4daa130fcff9f45cb8e.jpg";